var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options-file-picker"},[_vm._v("FilePicker")])}
var staticRenderFns = []

export { render, staticRenderFns }